import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@common-fe/common-fe';

const NoAccountsAvailableLabel = () => {
  const { t } = useTranslation();

  return (
    <Text
      size="small"
      style={{ maxWidth: 202 }}
    >
      {t('You don’t have any accounts available to cover expenses.')}
    </Text>
  );
};

export default NoAccountsAvailableLabel;
